import { Big } from 'big.js'
import {
  convertTwoDecimalStringToBig,
  formatBigFixedTwoDecimals,
} from '../utils/bigJSHelper'

type AmountWithCurrency = {
  amount: string
  currencyCode: string
}

interface BreakdownInput {
  amount: AmountWithCurrency
  count: number
}
export interface BreakdownDataProps<T extends BreakdownInput> {
  semesterStudentInfo: T
  semesterAdditionalStudentInfo: T
}

export type StudentInfo = {
  feeAmount: string
  numberOfStudents: number
  studentInfoSubTotal: string
  currencyCode: string
}

type Result = {
  firstStudent: StudentInfo
  additionalStudent: StudentInfo
  subTotal: string
  totalOfStudents: number
}

const useBreakdownDataLicensingFee = <T extends BreakdownInput>({
  semesterStudentInfo,
  semesterAdditionalStudentInfo,
}: BreakdownDataProps<T>): Result => {
  const semesterStudentInfoSubTotal: Big = convertTwoDecimalStringToBig(
    semesterStudentInfo.amount.amount
  ).times(semesterStudentInfo.count)

  const semesterAdditionalStudentInfoSubTotal: Big =
    convertTwoDecimalStringToBig(
      semesterAdditionalStudentInfo.amount.amount
    ).times(semesterAdditionalStudentInfo.count)

  const subTotal = formatBigFixedTwoDecimals(
    semesterStudentInfoSubTotal.plus(semesterAdditionalStudentInfoSubTotal)
  )

  const totalOfStudents =
    semesterStudentInfo.count + semesterAdditionalStudentInfo.count

  return {
    firstStudent: {
      feeAmount: semesterStudentInfo.amount.amount,
      numberOfStudents: semesterStudentInfo.count,
      studentInfoSubTotal: formatBigFixedTwoDecimals(
        semesterStudentInfoSubTotal
      ),
      currencyCode: semesterStudentInfo.amount.currencyCode,
    },
    additionalStudent: {
      feeAmount: semesterAdditionalStudentInfo.amount.amount,
      numberOfStudents: semesterAdditionalStudentInfo.count,
      studentInfoSubTotal: formatBigFixedTwoDecimals(
        semesterAdditionalStudentInfoSubTotal
      ),
      currencyCode: semesterAdditionalStudentInfo.amount.currencyCode,
    },
    subTotal,
    totalOfStudents,
  }
}

export default useBreakdownDataLicensingFee
